// 3rd-party modules
import 'reflect-metadata';
import camelcaseKeys from 'camelcase-keys';
import { Expose, plainToInstance } from 'class-transformer';

export class AccountKiboshDevice {
  @Expose()
  public accountKiboshDeviceId?: any;
  @Expose()
  public accountId?: number;
  @Expose()
  public kiboshDeviceName?: string;
  @Expose()
  public kiboshDeviceReference?: string;
  @Expose()
  public kiboshDeviceTypeId?: number;
  @Expose()
  public kiboshDeviceTypeCode?: string;
  @Expose()
  public kiboshDeviceType?: string;
  @Expose()
  public notes?: string;
  @Expose()
  public inactive?: boolean;
  @Expose()
  public isStandalone?: boolean;
  @Expose()
  public hasActiveSubscription?: boolean;
  @Expose()
  public lastSubscriptionId?: string;
  @Expose()
  public pin?: string;

  public static toClass(data: object) {
    //@ts-ignore
    return plainToInstance(AccountKiboshDevice, camelcaseKeys(data, { deep: true }), { excludeExtraneousValues: true });
  }

  public static toArrayOfClass(data: object[]) {
    //@ts-ignore
    return plainToInstance(AccountKiboshDevice, camelcaseKeys(data, { deep: true }) as AccountKiboshDevice[], { excludeExtraneousValues: true });
  }
}
